import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetCompany, PostCompanyForeignWorkerInfo } from '../services/httpServices';

import { styled } from '@mui/material/styles';
import { City, Country, State } from 'country-state-city';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ForeignWorkerInformation = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);

  const [gender, setGender] = useState('Male');
  const [statusInCanada, setStatusInCanada] = useState('Visitor');
  const [foreignWorkerEmployed, setForeignWorkerEmployed] = useState(false);
  const workerNameRef = useRef('');
  const dateOfBirthRef = useRef('');
  const placeOfBirthRef = useRef('');
  const citizenshipRef = useRef('');

  const startDateRef = useRef('');
  const endDateRef = useRef('');
  const [company, setCompany] = useState({});
  const [selectedPrevCountry, setSelectedPrevCountry] = useState(null);
  const [selectedPrevCity, setSelectedPrevCity] = useState(null);
  const [selectedCurrCountry, setSelectedCurrCountry] = useState(null);
  const [selectedCurrCity, setSelectedCurrCity] = useState(null);

  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };
  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    const city = City.getAllCities().find((e) => e.name == company.foriegnWorkerInformations[0]?.prewCity);
    const country = Country.getAllCountries().find((e) => e.name == company.foriegnWorkerInformations[0]?.prewCountry);
    setGender(company.foriegnWorkerInformations[0]?.gender);
    setStatusInCanada(company.foriegnWorkerInformations[0]?.statusInCanada);
    setForeignWorkerEmployed(company.foriegnWorkerInformations[0]?.foreignWorkerEmployed);
    setSelectedPrevCity(city);
    setSelectedPrevCountry(country);
    setSelectedCurrCity(
      Country.getAllCountries().find((e) => e.name == company.foriegnWorkerInformations[0]?.currentCity)
    );
    setSelectedCurrCountry(
      Country.getAllCountries().find((e) => e.name == company.foriegnWorkerInformations[0]?.currentCountry)
    );
    setCompany(company);
    setLoading(false);
  };

  useEffect(() => {
    fetchCompany();
  }, []);
  const SaveUser = async (event) => {
    setLoading(true);
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      name: workerNameRef.current.value,
      dateOfBirth: dateOfBirthRef.current.value,
      placeOfBirth: placeOfBirthRef.current.value,
      citizenship: citizenshipRef.current.value,
      // prewCity: prevCityRef.current.value,
      prewCity: selectedPrevCity?.name,
      // prewCountry: prevCountryRef.current.value,
      prewCountry: selectedPrevCountry?.name,
      currentCity: selectedCurrCity?.name,
      currentCountry: selectedCurrCountry?.name,
      startDate: startDateRef.current.value,
      endDate: endDateRef.current.value,
      statusInCanada: statusInCanada,
      gender: gender,
      foreignWorkerEmployed: foreignWorkerEmployed,
    };

    //console.log(payload);
    let response = await PostCompanyForeignWorkerInfo(id, payload);
    //console.log('PostResponse:', response);
    if (response.status == 200) {
      setLoading(false);
      props.setMessage("Company's Foriegn Worker Information saved.");
      props.setSaved(true);
      props.setOpen(true);
      let companySaved = company;
      companySaved.foriegnWorkerInformations[0] = response.data;
      setCompany(companySaved);
      // console.log('Id:', id);
      // setTimeout(() => {
      //   navigate(`/app/EditCompany/${id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const EndDateChangeHandle = () => {
    if (startDateRef.current.value > endDateRef.current.value) {
      endDateRef.current.value = '';
      alert('End Date should be Greater then start date! ');
    }
  };
  const handleChangeGender = (event) => {
    setGender(event.target.value);
  };
  const handleChangeStatus = (event) => {
    setStatusInCanada(event.target.value);
  };
  const handleChangeForeignWorkerEmployed = (event) => {
    event.target.value == 'true' ? setForeignWorkerEmployed(true) : setForeignWorkerEmployed(false);
    if (event.target.value == 'true') {
      startDateRef.current.value = company.foriegnWorkerInformations[0]?.startDate?.split('T')[0];
      endDateRef.current.value = company.foriegnWorkerInformations[0]?.endDate?.split('T')[0];
    } else {
      startDateRef.current.value = '';
      endDateRef.current.value = '';
    }
  };
  // console.log('COUTRIES', Country.getAllCountries());
  // console.log('STATES', State.getAllStates());
  // console.log('Cities', City.getAllCities());
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <TextField
                      label="Worker's Name"
                      required
                      variant="outlined"
                      fullWidth
                      defaultValue={company.foriegnWorkerInformations[0]?.name}
                      size="small"
                      inputRef={workerNameRef}
                    />
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <TextField
                      label="Date of Birth"
                      type="date"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.foriegnWorkerInformations[0]?.dateOfBirth?.split('T')[0]}
                      InputLabelProps={{ shrink: true }}
                      inputRef={dateOfBirthRef}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <TextField
                      label="Place of Birth"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.foriegnWorkerInformations[0]?.placeOfBirth}
                      inputRef={placeOfBirthRef}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <TextField
                      label="Citizenship"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.foriegnWorkerInformations[0]?.citizenship}
                      inputRef={citizenshipRef}
                    />
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="preCountry"
                      size="small"
                      options={Country.getAllCountries()}
                      defaultValue={Country.getAllCountries().find(
                        (e) => e.name == company.foriegnWorkerInformations[0]?.prewCountry
                      )}
                      getOptionLabel={(country) => country.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // inputRef={prevCountryRef}
                          label="Previous Country of Residence"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, country) => setSelectedPrevCountry(country)}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="preCity"
                      size="small"
                      options={City.getAllCities().filter((e) => e.countryCode == selectedPrevCountry?.isoCode)}
                      defaultValue={City.getAllCities().find(
                        (e) => e.name == company.foriegnWorkerInformations[0]?.prewCity
                      )}
                      getOptionLabel={(city) => city?.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // inputRef={prevCountryRef}
                          label="Previous City"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, city) => setSelectedPrevCity(city)}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <Autocomplete
                      size="small"
                      options={Country.getAllCountries()}
                      defaultValue={Country.getAllCountries().find(
                        (e) => e.name == company.foriegnWorkerInformations[0]?.currentCountry
                      )}
                      getOptionLabel={(country) => country.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // inputRef={prevCountryRef}
                          label="Current Country of Residence"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, country) => setSelectedCurrCountry(country)}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <Autocomplete
                      size="small"
                      options={City.getAllCities().filter((e) => e.countryCode == selectedCurrCountry?.isoCode)}
                      defaultValue={City.getAllCities().find(
                        (e) => e.name == company.foriegnWorkerInformations[0]?.currentCity
                      )}
                      getOptionLabel={(city) => city?.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // inputRef={prevCountryRef}
                          label="Current City"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, city) => setSelectedCurrCity(city)}
                    />
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">What is his/her status in Canada?</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={statusInCanada}
                        onChange={handleChangeStatus}
                      >
                        <FormControlLabel value="Visitor" control={<Radio />} label="Visitor" />
                        <FormControlLabel value="Work Permit" control={<Radio />} label="Work Permit" />
                        <FormControlLabel value="Open Permit" control={<Radio />} label="Open Permit" />
                        <FormControlLabel value="Student" control={<Radio />} label="Student" />
                        <FormControlLabel value="Refugee" control={<Radio />} label="Refugee" />
                        <FormControlLabel value="Restoration" control={<Radio />} label="Restoration" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={gender}
                        onChange={handleChangeGender}
                      >
                        <FormControlLabel value="Male" control={<Radio />} label="Male" />
                        <FormControlLabel value="Female" control={<Radio />} label="Female" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={3}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        The foreign worker was employed with the company
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={foreignWorkerEmployed}
                        onChange={handleChangeForeignWorkerEmployed}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={3}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">If yes;</FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Start Date"
                        type="date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        onChange={EndDateChangeHandle}
                        disabled={!foreignWorkerEmployed}
                        defaultValue={company.foriegnWorkerInformations[0]?.startDate?.split('T')[0]}
                        InputLabelProps={{ shrink: true }}
                        inputRef={startDateRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="End Date"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        onChange={EndDateChangeHandle}
                        disabled={!foreignWorkerEmployed}
                        defaultValue={company.foriegnWorkerInformations[0]?.endDate?.split('T')[0]}
                        inputRef={endDateRef}
                      />
                    </Item>
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );

  //   return <>User</>;
};

export default ForeignWorkerInformation;
